module.exports = __webpack_public_path__ + "static/img/1_v2.09e65801.png";